<form [formGroup]="registrationForm">
    <div class="text-center mb-5">
        <!-- <h1 class="custom-tag" [ngClass]="getSeverityClass(getSeverity(status))" style="text-align: center">
          {{headerStatus}}</h1> -->
        <img *ngIf="propertiery_img" [src]="FRAPPE_API_URL + propertiery_img" class="vendor-image"
          width="250px">
        <img *ngIf="!propertiery_img || propertiery_img === ''"
          src="https://netmat.in/demo/vendor/img/user.png" alt="{{ business_name }}"
          style="width: 150px; border-radius: 75px; border: solid 2px orange;">
        <h4 class="card-title" style="color: black;"><strong><u>{{business_name}}</u></strong></h4>
      </div>
    <div class="card p-fluid">
        <div class="grid">
            <div class="col" style="display: flex; justify-content: start; " *ngIf="is_purchase_approver_1 || is_finance_approver_2 || isPurchase">
              <p-button pRipple label="Change Summary" icon="pi pi-eye" class="mr-2"
                (click)="openSummaryDialog()"></p-button>
            </div>
          </div>
      <header class="black-center mb-5 w-full">
        <!-- <h5 class="mt-3 white-col"><strong>CHANGE DETAIL</strong></h5> -->
        <h5 class="mt-3 white-col" [ngClass]="getSeverity(status)" style="text-align: center">
            {{headerStatus}}</h5>
        </header>
      <div class="p-formgrid grid">
        <div class="field col feild-bg" >
          <label for="Company_Title"><strong>Company Title</strong></label>
          <p-dropdown [options]="Company_Title" id="Company_Title" formControlName="company_title"
            placeholder="Select an Option" [readonly]="isNotEditable"></p-dropdown>
        </div>
        <div class="field col feild-bg">
          <label for="business_name" class="label-spacing"><strong>Vendor Name</strong>&nbsp;&nbsp;&nbsp;</label>
          <input id="business_name" type="text" [readonly]="isNotEditable" pInputText formControlName="business_name" />
        </div>
        <div class="field col feild-bg" *ngIf="isFinalApproved">
          <label for="short_name"><strong>Vendor Code</strong>&nbsp;&nbsp;&nbsp;</label>
          <input id="short_name" type="text" pInputText formControlName="vendor_code" [readonly]="isNotEditable"/>
        </div>
      </div>
      <div class="p-formgrid grid">
        <div class="field col" >
          <label for="short_name"><strong>Short Name</strong>&nbsp;&nbsp;&nbsp;</label>
          <input id="short_name" type="text" pInputText formControlName="short_name" [readonly]="isNotEditable" [ngClass]="{'highlight': highlightStatus['short_name']}"/>
        </div>

        <div class="field col" [ngClass]="{'highlight': highlightStatus['plant']}">
          <label for="country"><strong>Plant</strong></label>
          <!-- <input
                id="country"
                type="text"
                pInputText
                formControlName="country"
              /> -->
          <p-dropdown [options]="plantList" id="plant" [readonly]="isNotEditable" formControlName="plant" optionValue="plant__code" placeholder="Select an Option"
            optionLabel="name1"></p-dropdown>
        </div>
      </div>
      <!-- <header class="orange-center">
          <p><strong>PRIMARY ADDRESS</strong></p>
        </header> -->
      <div formGroupName="primary_address" >
        <div class="p-formgrid grid">
          <div class="field col feild-bg">
            <label for="address_title"><strong>Address Title</strong>&nbsp;&nbsp;&nbsp;</label>
            <input id="address_title" type="text" pInputText formControlName="address_title" [ngClass]="{'highlight': highlightStatus['primary_address.address_title']}"/>
          </div>
          <div class="field col feild-bg">
            <label for="address_line_1"><strong>Street / House Number</strong>&nbsp;&nbsp;&nbsp;</label>
            <input id="address_line_1" type="text" pInputText formControlName="address_line_1"  [ngClass]="{'highlight': highlightStatus['primary_address.address_line_1']}"/>
          </div>
          <!-- <div class="field col feild-bg" [ngClass]="{'highlight': highlightStatus['primary_address.address_type']}">
            <label><strong>Address Type</strong></label>
            <p-dropdown [options]="options1" formControlName="address_type" placeholder="Select an Option"></p-dropdown>
          </div> -->
        </div>
        <div class="p-formgrid grid">

          <div class="field col" >
            <label for="address_line_2"><strong>District</strong></label>
            <input id="address_line_2" type="text" pInputText formControlName="address_line_2" [ngClass]="{'highlight': highlightStatus['primary_address.address_line_2']}"/>
          </div>
          <div class="field col" [ngClass]="{'highlight': highlightStatus['primary_address.country']}">
            <label for="country"><strong>Country</strong></label>
            <p-dropdown [options]="countries_List" id="country" formControlName="country" placeholder="Select an Option"
              (onChange)="onStateChange($event.value)" ></p-dropdown>
          </div>
        </div>
        <div class="p-formgrid grid">
          <div class="field col feild-bg" >
            <label for="city"><strong>City</strong></label>
            <input id="city" type="text" pInputText formControlName="city" [ngClass]="{'highlight': highlightStatus['primary_address.city']}"/>
          </div>
          <!-- <div class="field col feild-bg" [ngClass]="{'highlight': highlightStatus['primary_address.city']}">
            <label for="city"><strong>City</strong></label>
            <p-dropdown formControlName="city"  [options]="cityAndStateList" optionLabel="name" placeholder="Select a City" />
          </div> -->
          <!-- <div class="field col feild-bg" *ngIf="hideState" [ngClass]="{'highlight': highlightStatus['primary_address.state']}">
            <label for="state"><strong>State/Province</strong></label>
            <p-dropdown formControlName="state" [options]="state" optionLabel="label" placeholder="Select a State" />
          </div> -->
          <div class="field col feild-bg">
            <label for="state"><strong>State/Province</strong></label>
            <input id="state" type="text" pInputText formControlName="state" [ngClass]="{'highlight': highlightStatus['primary_address.state']}"/>
          </div>
        </div>

        <div class="p-formgrid grid">

          <div class="field col">
            <label for="postal_code"><strong>Postal Code</strong></label>
            <input id="postal_code" type="text" (keydown)="validatePostalCode($event)" (keydown)="validateNumber($event)"
              pInputText formControlName="postal_code"  [ngClass]="{'highlight': highlightStatus['primary_address.postal_code']}"/>
          </div>
          <div class="field col" >
            <label for="fax"><strong>Fax</strong></label>
            <input id="fax" type="text" pInputText formControlName="fax" [ngClass]="{'highlight': highlightStatus['primary_address.fax']}"/>
          </div>
        </div>
        <!-- <div class="p-formgrid grid"> -->

          <!-- <div class="field col"></div> -->
          <!-- <div class="field col"></div> -->
        <!-- </div> -->
      </div>
      <div class="p-formgrid grid">
        <div class="field col" >
          <label for="MCA"><strong>Ministry Of Corporate Affairs(MCA)</strong></label>
          <p-dropdown [options]="MCA" id="MCA" formControlName="ministry_of_corporate_affairsmca"
            placeholder="Select an Option" [ngClass]="{'highlight': highlightStatus['ministry_of_corporate_affairsmca']}"></p-dropdown>
        </div>
        <div class="field col" *ngIf="ismca()">
          <label for="mca_number"><strong>MCA Number</strong></label>
          <input id="mca_number" type="text" pInputText formControlName="mca_number" [ngClass]="{'highlight': highlightStatus['mca_number']}"/>
        </div>
        <div class="field col" style="width: fit-content" *ngIf="ismca()">
            <label htmlFor="Cancel-cheq">
              <strong>MCA Document</strong>
            </label>
            <div class="p-formgrid grid">
              <div class="field col">
                <button pButton class="btn btn-primary" *ngIf="mca_documentUrl" style="max-width: min-content;"
                (click)="downloadFile(mca_documentUrl, 'mca_document')">
                <i class="pi pi-download"></i>
              </button>
              </div>
            </div>
          </div>
          <div class="field col" *ngIf="!ismca()"></div>
      </div>
      <div class="p-formgrid grid">
        <div class="field col feild-bg" >
          <label for="GST Registered"><strong>GST Registered</strong></label>
          <p-dropdown [options]="GST_Registered" id="GST_Registered" formControlName="gst_registered"
            placeholder="Select one from below" (onChange)="updateGstnValidators($event.value)"></p-dropdown>
        </div>
        <div class="field col feild-bg" [ngClass]="{'highlight': highlightStatus['select_industry_type']}">
          <label for="GST Registered"><strong>Select Industry Type</strong></label>
        <p-dropdown [options]="SelectIndustryType" id="SelectIndustryType" formControlName="select_industry_type"
          placeholder="Select one from below" optionLabel="label" optionValue="value" (onChange)="SelectIndustryType1($event.value)"></p-dropdown>
        </div>
      </div>
      <div formGroupName="primary_address">
        <div formGroupName="tax_details">
          <div class="p-formgrid grid" *ngIf="isGSTRegistered()">
            <div class="field col">
              <label htmlFor="gstn"><strong>GST Number</strong></label>
              <input id="gstn" type="text" pInputText formControlName="gstn" [readonly]="isNotEditable" (blur)="onGstnBlur($event)"
                (keydown)="onGstnInput($event)" [class.error]="
                  gstnNumber &&
                  gstnNumber.invalid &&
                  (gstnNumber.dirty || gstnNumber.touched)
                " />
              <div *ngIf="
                  gstnNumber &&
                  gstnNumber.invalid &&
                  (gstnNumber.dirty || gstnNumber.touched)
                ">
                <div *ngIf="gstnNumber.errors && gstnNumber.errors['required']" style="color: red">
                  GST Number is required
                </div>
                <div *ngIf="gstnNumber.errors && gstnNumber.errors['invalidGstn']" style="color: red">
                  Invalid GST Number
                </div>
              </div>
            </div>
            <div class="field col" style="width: fit-content">
                <label htmlFor="Cancel-cheq">
                  <strong>GST Document</strong>
                </label>
                <div class="p-formgrid grid">
                  <div class="field col">
                    <button pButton class="btn btn-primary" *ngIf="upload_gstUrl"
                    style="max-width: min-content;" (click)="downloadFile(upload_gstUrl, 'upload_gst')">
                    <i class="pi pi-download"></i>
                  </button>
                  </div>
                </div>
              </div>
          </div>
          <div class="p-formgrid grid">
            <div class="field col" >
              <label for="vat_registration_number"><strong>VAT Registration Number</strong></label>
              <input id="vat_registration_number" type="text" pInputText formControlName="vat_registration_number" [ngClass]="{'highlight': highlightStatus['primary_address.tax_details.vat_registration_number']}"/>
            </div>
            <div class="field col" >
              <label for="service_tax_registration_number"><strong>Service Tax Registration Number</strong></label>
              <input id="service_tax_registration_number" type="text" pInputText
                formControlName="service_tax_registration_number" [ngClass]="{'highlight': highlightStatus['primary_address.tax_details.service_tax_registration_number']}" />
            </div>
          </div>
          <!-- <div class="p-formgrid grid">
            <div class="field col"></div>
          </div> -->
        </div>
      </div>
      <div class="p-formgrid grid">
        <div class="field col feild-bg" [ngClass]="{'highlight': highlightStatus['vendor_type']}">
          <label for="GST Registered"><strong>Vendor Type</strong></label>
          <p-dropdown [options]="VendorType" id="VendorType" formControlName="vendor_type"
            placeholder="Select one from below" ></p-dropdown>
        </div>
        <div class="field col feild-bg" style="width: fit-content">
          <div class="p-formgrid grid">
            <div class="field col">
              <button pButton class="btn btn-primary" style="max-width: min-content" *ngIf="propertiery_imgUrl"
                (click)="downloadFile(propertiery_imgUrl, 'propertiery_img')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <header class="orange-center">
        <p><strong>VENDOR CLASSIFICATION</strong></p>
      </header>
      <div class="p-formgrid grid mt-3">
        <div class="field col" [ngClass]="{'highlight': highlightStatus['vendor_classification']}">
          <label for="vendor_classification"><strong>Vendor Classification</strong></label>
          <p-dropdown [options]="options" id="vendor_classification" formControlName="vendor_classification"
            placeholder="Select an Option" ></p-dropdown>
        </div>
      </div>
      <header class="orange-center">
        <p><strong>TURN OVER DETAILS</strong></p>
      </header>
      <div class="p-formgrid grid mt-3">
        <div class="field col feild-bg" >
          <label for="previous_year"><strong>Financial Year {{ financialPreviousYear }} (In
              Lakhs)</strong>&nbsp;&nbsp;&nbsp;</label>
          <input id="previous_year" type="number" (keydown)="validateNumber($event)" pInputText
            formControlName="previous_year" [ngClass]="{'highlight': highlightStatus['previous_year']}"/>
        </div>
        <div class="field col feild-bg" >
          <label for="one_year_before_previous_year" class="label-spacing"><strong>Financial Year {{
              financialOneYearBeforePreviousYear }} (In
              Lakh)</strong>&nbsp;&nbsp;&nbsp;</label>
          <input id="one_year_before_previous_year" type="number" (keydown)="validateNumber($event)" pInputText
            formControlName="one_year_before_previous_year" [ngClass]="{'highlight': highlightStatus['one_year_before_previous_year']}" />
        </div>
      </div>
      <div class="p-formgrid grid">
        <div class="field col" >
          <label for="two_years_before_previous_year"><strong>Financial Year {{ financialtwoYearsBeforePreviousYear }} (In
              Lakh)&nbsp;&nbsp;&nbsp;</strong></label>
          <input id="two_years_before_previous_year" type="number" (keydown)="validateNumber($event)" pInputText
            formControlName="two_years_before_previous_year" [ngClass]="{'highlight': highlightStatus['two_years_before_previous_year']}"/>
        </div>
        <div class="field col"></div>
      </div>
      <form [formGroup]="multipleBankDetailForm">
        <div formArrayName="multipleBank">
          <div class="border-1 border-round surface-border">
            <header class="orange-center p-2">
              <p class="font-bold m-0">BANK DETAILS</p>
            </header>

            <div class="overflow-x-auto" style="min-width: 100%">
              <div *ngFor="let bank of multipleBank.controls; let i = index" [formGroupName]="i">
                <div class="flex flex-nowrap p-3 gap-3" style="min-width: max-content">
                  <div class="field">
                    <label [for]="'country'+i" class="font-bold block mb-2">Country</label>
                    <input [id]="'country'+i" type="text" pInputText [disabled]="true" value="IN" [ngStyle]="{ 'width': '50px' }"/>
                  </div>

                  <div class="field" style="max-width: 150px">
                    <label [for]="'ifsc_code'+i" class="font-bold block mb-2">IFSC Code</label>
                    <input [id]="'ifsc_code'+i" type="text" pInputText class="w-full"
                      formControlName="ifsc_code"
                      (keydown)="validateIFSCCode($event)"
                      [ngClass]="multipleBankHighlightClass(i, 'ifsc_code')" />
                  </div>

                  <div class="field" style="max-width: 160px">
                    <label [for]="'account_no'+i" class="font-bold block mb-2">Account No</label>
                    <input [id]="'account_no'+i" type="text" pInputText class="w-full"
                      (keydown)="validateNumber($event)"
                      formControlName="account_no"
                      [ngClass]="multipleBankHighlightClass(i, 'account_no')" />
                  </div>

                  <div class="field" style="min-width: 250px">
                    <label [for]="'account_holder__registered_name'+i" class="font-bold block mb-2">Account Holder/Name</label>
                    <input [id]="'account_holder__registered_name'+i" type="text" pInputText class="w-full"
                      formControlName="account_holder__registered_name"
                      [ngClass]="multipleBankHighlightClass(i, 'account_holder__registered_name')" />
                  </div>

                  <div class="field" style="width: 250px">
                    <label [for]="'plant_code'+i" class="font-bold block mb-2">Plant Code</label>
                    <input [id]="'plant_code'+i" type="text" pInputText class="w-full"
                      formControlName="plant_code"
                      [ngClass]="multipleBankHighlightClass(i, 'plant_code')" />
                  </div>

                  <div class="field" style="min-width: 200px">
                    <label [for]="'bank_name'+i" class="font-bold block mb-2">Bank Name</label>
                    <input [id]="'bank_name'+i" type="text" pInputText class="w-full"
                      formControlName="bank_name"
                      [ngClass]="multipleBankHighlightClass(i, 'bank_name')" />
                  </div>

                  <div class="field" style="min-width: 200px">
                    <label [for]="'branch_name'+i" class="font-bold block mb-2">Branch Name</label>
                    <input [id]="'branch_name'+i" type="text" pInputText class="w-full"
                      formControlName="branch_name"
                      [ngClass]="multipleBankHighlightClass(i, 'branch_name')" />
                  </div>

                  <div class="field" style="min-width: 150px" *ngIf="bank.get('cancelled_cheque')?.value">
                    <label [for]="'Cancel-cheq'+i" class="font-bold block mb-2">Bank Document</label>
                    <button pButton class="p-button-primary"
                      (click)="downloadFileForBanks(i, 'cancelled_cheque_' + i)">
                      <i class="pi pi-download mr-2"></i>Download
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>


      <header class="orange-center">
        <p><strong>LEGAL DETAILS</strong></p>
      </header>

      <div class="p-formgrid grid mt-5">
        <div class="field col bg-feild" >
          <label for="pan_no"><strong>PAN No</strong>&nbsp;&nbsp;&nbsp;</label>
          <input id="pan_no" type="text" pInputText formControlName="pan_no" (keydown)="onPanNoInput($event)" [ngClass]="{'highlight': highlightStatus['pan_no']}"
            [readonly]="isDisablePan" [class.error]="
              panNumber &&
              panNumber.invalid &&
              (panNumber.dirty || panNumber.touched)
            " />
          <div *ngIf="
              panNumber &&
              panNumber.invalid &&
              (panNumber.dirty || panNumber.touched)
            ">
            <div *ngIf="panNumber.errors && panNumber.errors['required']" style="color: red">
              PAN Number is required
            </div>
            <div *ngIf="panNumber.errors && panNumber.errors['invalidPan']" style="color: red">
              Invalid PAN Number
            </div>
          </div>
        </div>
        <div class="field col">
            <div class="field col" style="width: fit-content">
                <label htmlFor="Cancel-cheq">
                    <label for="msme_no"><strong>Pan Document</strong></label>
                </label>
                <div class="p-formgrid grid">
                  <div class="field col">
                    <button pButton class="btn btn-primary" style="max-width: min-content;"
                    *ngIf="pan_documentUrl" (click)="downloadFile(pan_documentUrl, 'pan_document')">
                    <i class="pi pi-download"></i>
                  </button>
                  </div>
                </div>
              </div>
        </div>
      </div>
      <div *ngIf="isIndustry" class="p-formgrid grid">
        <div class="field col feild-bg" >
          <label for="msme_no"><strong>MSME No</strong></label>
          <input id="msme_no" type="text" pInputText formControlName="msme_no" [ngClass]="{'highlight': highlightStatus['msme_no']}"/>
        </div>
        <div class="field col feild-bg" [ngClass]="{'highlight': highlightStatus['msme_expiry_year']}">
          <label for="msme_no"><strong>Expiry year</strong></label>
          <p-dropdown [options]="msmeYearList" formControlName="msme_expiry_year" optionLabel="year" optionValue="year" placeholder="Select Expiry year"
            (onChange)="onMsmeExpiryYearChange($event.value)" />
          <div *ngIf="enableMSMEYearInvalidMessage" style="color: red">
            Your MSME Certificate is expired please renew before on boarding
          </div>
        </div>
        <div class="field col feild-bg">
          <!-- <div class="p-formgrid grid">
            <div class="field col">
              <label for="msme_no"><strong>MSME Certificate</strong></label>
            </div>
            <div class="field col">
              <button pButton class="btn btn-primary" style="max-width: min-content; margin-top: 30px;"
                *ngIf="msme_certificateUrl" (click)="downloadFile(msme_certificateUrl, 'msme_certificate')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div> -->
          <div class="field col" style="width: fit-content">
            <label htmlFor="Cancel-cheq">
                <label for="msme_no"><strong>MSME Certificate</strong></label>
            </label>
            <div class="p-formgrid grid">
                <div class="field col">
                    <button pButton class="btn btn-primary" style="max-width: min-content;"
                      *ngIf="msme_certificateUrl" (click)="downloadFile(msme_certificateUrl, 'msme_certificate')">
                      <i class="pi pi-download"></i>
                    </button>
                  </div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-formgrid grid">
        <div class="field col" >
          <label for="cin_no"><strong>CIN No</strong>&nbsp;&nbsp;&nbsp;</label>
          <input id="cin_no" type="text" pInputText formControlName="cin_no" [ngClass]="{'highlight': highlightStatus['cin_no']}"/>
        </div>
        <div class="field col">
          <div class="p-formgrid grid">
            <div class="field col" style="width: fit-content">
                <label htmlFor="Cancel-cheq">
                    <label for="msme_no"><strong>CIN</strong></label>
                </label>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <button pButton class="btn btn-primary" style="max-width: min-content;"
                          *ngIf="upload_cinUrl" (click)="downloadFile(upload_cinUrl, 'upload_cin')">
                          <i class="pi pi-download"></i>
                        </button>
                      </div>
                </div>
              </div>
          </div>
        </div>
      </div>
      <div class="p-formgrid grid">
        <div class="field col feild-bg" >
          <label for="legal_name"><strong>Legal Name</strong>&nbsp;&nbsp;&nbsp;</label>
          <input id="legal_name" type="text" pInputText formControlName="legal_name" [ngClass]="{'highlight': highlightStatus['legal_name']}"/>
        </div>
        <div class="field col feild-bg" >
          <label for="tin_no"><strong>TIN No</strong>&nbsp;&nbsp;&nbsp;</label>
          <input id="tin_no" type="text" pInputText formControlName="tin_no" [ngClass]="{'highlight': highlightStatus['tin_no']}"/>
        </div>
      </div>
      <div class="p-formgrid grid">
        <div class="field col">
          <label for="aadhar_no"><strong>Aadhar No</strong></label>
          <input id="aadhar_no" type="number" (keydown)="validateAadharNumber($event)" pInputText
            formControlName="aadhar_no"  [ngClass]="{'highlight': highlightStatus['aadhar_no']}"/>
          <div *ngIf="registrationForm.get('aadhar_no')?.errors" style="color: red">
            Aadhar number must be exactly 12 digits long.
          </div>
        </div>
        <div class="field col" >
          <label for="din_no"><strong>DIN No</strong>&nbsp;&nbsp;&nbsp;</label>
          <input id="din_no" type="text" pInputText formControlName="din_no" [ngClass]="{'highlight': highlightStatus['din_no']}" />
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="field col feild-bg" style="width: fit-content">
          <div class="p-formgrid grid">
            <div class="field col">
                <div class="p-formgrid grid">
                  <div class="field col" style="width: fit-content">
                      <label htmlFor="Cancel-cheq">
                          <label for="msme_no"><strong>Self Declaration By Vendor</strong></label>
                      </label>
                      <div class="p-formgrid grid">
                          <div class="field col">
                            <button pButton class="btn btn-primary" style="max-width: min-content" *ngIf="self_declaration_by_vendorUrl"
                            (click)="
                              downloadFile(
                                self_declaration_by_vendorUrl,
                                'self_declaration_by_vendor'
                              )
                            ">
                            <i class="pi pi-download"></i>
                          </button>
                            </div>
                      </div>
                    </div>
                </div>
              </div>

          </div>
        </div>
        <!-- </div> -->
        <div class="field col feild-bg" style="width: fit-content">
          <div class="p-formgrid grid">
            <div class="p-formgrid grid">
                <div class="field col">
                    <div class="p-formgrid grid">
                      <div class="field col" style="width: fit-content">
                          <label htmlFor="Cancel-cheq">
                              <label for="msme_no"><strong>Company Registration</strong></label>
                          </label>
                          <div class="p-formgrid grid">
                              <div class="field col">
                                <button pButton class="btn btn-primary" style="max-width: min-content" *ngIf="company_registrationUrl"
                                        (click)="
                                        downloadFile(company_registrationUrl, 'company_registration')
                                        ">
                                        <i class="pi pi-download"></i>
                                    </button>
                                </div>
                          </div>
                        </div>
                    </div>
                  </div>

              </div>
          </div>
        </div>
        <div class="field col feild-bg">
            <div class="p-formgrid grid">
              <div class="field col" style="width: fit-content">
                  <label htmlFor="Cancel-cheq">
                      <label for="msme_no"><strong>Other</strong></label>
                  </label>
                  <div class="p-formgrid grid">
                      <div class="field col">
                        <button pButton class="btn btn-primary" style="max-width: min-content;"
                            *ngIf="other_documentsUrl" (click)="downloadFile(other_documentsUrl, 'other_documents')">
                            <i class="pi pi-download"></i>
                        </button>
                        </div>
                  </div>
                </div>
            </div>
          </div>
      </div>


      <header class="orange-center">
        <p><strong>DOCUMENTS REQUIRED IN EVALUATION SHEET</strong></p>
      </header>
      <div class="p-formgrid grid mt-3">
        <div class="field col">

          <div class="p-formgrid grid">
            <div class="field col feild-bg">
                <div class="p-formgrid grid">
                  <div class="field col" style="width: fit-content">
                      <label htmlFor="Cancel-cheq">
                          <label for="msme_no"><strong>Evaluation Sheet</strong></label>
                      </label>
                      <div class="p-formgrid grid">
                          <div class="field col">
                            <button pButton class="btn btn-primary" *ngIf="evaluationSheetUrl" style="max-width: min-content"
                                    (click)="downloadFile(evaluationSheetUrl, 'evaluation_sheet')">
                                    <i class="pi pi-download"></i>
                                </button>
                            </div>
                      </div>
                    </div>
                </div>
              </div>
          </div>
        </div>
        <div class="field col" style="width: fit-content">
          <div class="p-formgrid grid">
            <div class="field col" >
              <label for="din_no"><strong>Company Profile</strong>&nbsp;&nbsp;&nbsp;</label>
              <input id="din_no" type="text" pInputText formControlName="document_1_name" [ngClass]="{'highlight': highlightStatus['document_1_name']}"/>
            </div>
            <div class="field col">
                <div class="p-formgrid grid">
                  <div class="field col" style="width: fit-content">
                      <div class="p-formgrid grid">
                          <div class="field col">
                            <button pButton class="btn btn-primary" style="max-width: min-content;margin-top:30px" *ngIf="document1Url"
                                (click)="downloadFile(document1Url, 'document_1')">
                                <i class="pi pi-download"></i>
                            </button>
                            </div>
                      </div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
      <div class="p-formgrid grid mt-3">
        <div class="field col feild-bg">

          <div class="p-formgrid grid">
            <div class="field col" >
              <label for="din_no"><strong>Balance Sheet</strong>&nbsp;&nbsp;&nbsp;</label>
              <input id="din_no" type="text" pInputText formControlName="document_2_name" [ngClass]="{'highlight': highlightStatus['document_2_name']}"/>
            </div>

            <div class="field col feild-bg">
                <div class="p-formgrid grid">
                  <div class="field col" style="width: fit-content">
                      <div class="p-formgrid grid">
                          <div class="field col">
                            <button pButton class="btn btn-primary" style="max-width: min-content;margin-top:30px" *ngIf="document2Url"
                            (click)="downloadFile(document2Url, 'document_2')">
                            <i class="pi pi-download"></i>
                          </button>
                            </div>
                      </div>
                    </div>
                </div>
              </div>
          </div>
        </div>
        <div class="field col feild-bg" style="width: fit-content">

          <div class="p-formgrid grid">
            <div class="field col" >
              <label for="din_no"><strong>Auditor Report</strong>&nbsp;&nbsp;&nbsp;</label>
              <input id="din_no" type="text" pInputText formControlName="document_3_name" [ngClass]="{'highlight': highlightStatus['document_3_name']}"/>
            </div>
            <div class="field col feild-bg">
                <div class="p-formgrid grid">
                  <div class="field col" style="width: fit-content">
                      <div class="p-formgrid grid">
                          <div class="field col feild-bg">
                            <button pButton class="btn btn-primary" style="max-width: min-content;margin-top:30px" *ngIf="document3Url"
                                    (click)="downloadFile(document3Url, 'document_3')">
                                    <i class="pi pi-download"></i>
                                </button>
                            </div>
                      </div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="field col" style="width: fit-content">
          <div class="p-formgrid grid">
            <div class="field col" >
              <label for="din_no"><strong>ISO Certificate</strong>&nbsp;&nbsp;&nbsp;</label>
              <input id="din_no" type="text" pInputText formControlName="document_4_name" [ngClass]="{'highlight': highlightStatus['document_4_name']}"/>
            </div>
            <div class="field col">
                <div class="p-formgrid grid">
                  <div class="field col" style="width: fit-content">
                      <div class="p-formgrid grid">
                          <div class="field col">
                            <button pButton class="btn btn-primary" style="max-width: min-content;margin-top:30px" *ngIf="document4Url"
                                (click)="downloadFile(document4Url, 'document_4')">
                                <i class="pi pi-download"></i>
                            </button>
                            </div>
                      </div>
                    </div>
                </div>
            </div>
          </div>
        </div>

        <div class="field col" style="width: fit-content">
          <div class="p-formgrid grid">
            <div class="field col" >
              <label for="din_no"><strong>List Of Equipment</strong>&nbsp;&nbsp;&nbsp;</label>
              <input id="din_no" type="text" pInputText formControlName="document_5_name" [ngClass]="{'highlight': highlightStatus['document_5_name']}"/>
            </div>
            <div class="field col">
                <div class="p-formgrid grid">
                  <div class="field col" style="width: fit-content">
                      <div class="p-formgrid grid">
                          <div class="field col">
                            <button pButton class="btn btn-primary" style="max-width: min-content;margin-top:30px" *ngIf="document5Url"
                            (click)="downloadFile(document5Url, 'document_5')">
                            <i class="pi pi-download"></i>
                          </button>
                            </div>
                      </div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
      <div class="p-formgrid grid">
        <div class="field col feild-bg" style="width: fit-content">
          <div class="p-formgrid grid">
            <div class="field col" >
              <label for="din_no"><strong>Other</strong>&nbsp;&nbsp;&nbsp;</label>
              <input id="din_no" type="text" pInputText formControlName="document_6_name" [ngClass]="{'highlight': highlightStatus['document_6_name']}" />
            </div>
            <div class="field col feild-bg">
                <div class="p-formgrid grid">
                  <div class="field col" style="width: fit-content">
                      <div class="p-formgrid grid">
                          <div class="field col feild-bg">
                            <button pButton class="btn btn-primary" style="max-width: min-content;margin-top:30px" *ngIf="document6Url"
                            (click)="downloadFile(document6Url, 'document_6')">
                            <i class="pi pi-download"></i>
                          </button>
                            </div>
                      </div>
                    </div>
                </div>
              </div>
          </div>
        </div>

        <div class="field col"></div>
      </div>
      <header class="orange-center mb-5" *ngIf="false">
        <p><strong>CONTACT DETAILS</strong></p>
      </header>
      <div formGroupName="primary_address">
        <div formGroupName="contact_person">
          <div class="p-formgrid grid" *ngIf="false">
            <div class="field col">
              <label for="name1"><strong>Name</strong>&nbsp;&nbsp;&nbsp;</label>
              <input id="name1" type="text" pInputText formControlName="name1" />
            </div>
            <div class="field col">
              <label for="phone_no"><strong>Phone No</strong>&nbsp;&nbsp;&nbsp;</label>
              <input id="phone_no" type="text" (keydown)="validateNumber($event)" pInputText formControlName="phone_no" />
            </div>
          </div>
          <div class="p-formgrid grid" *ngIf="false">
            <div class="field col">
              <label for="mobile_no"><strong>Mobile No</strong></label>
              <p-dropdown [options]="countries" formControlName="mobile_no" placeholder="Select a country"
                [editable]="true" (onChange)="updateMobileNoCode($event)" />
            </div>
            <div class="field col">
              <label for="e_mail_id"><strong>E Mail ID</strong>&nbsp;&nbsp;&nbsp;</label>
              <input id="e_mail_id" type="email" pInputText formControlName="e_mail_id" />
            </div>
          </div>
          <div class="p-formgrid grid" *ngIf="false">
            <div class="field col">
              <label for="website_url"><strong>Website/ URL</strong>&nbsp;&nbsp;&nbsp;</label>
              <input id="website_url" type="text" pInputText formControlName="website_url" />
            </div>
            <div class="field col">
              <label for="website_url"><strong>Alternate Email Id </strong></label>
              <input id="website_url" type="text" pInputText formControlName="alternate_email_id" />
              <div *ngIf="registrationForm.hasError('emailMatch2')">
                <p style="color: red">
                  Please make sure the Email id are unique.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <header class="orange-center mb-5">
        <p><strong>CONTACT DETAILS</strong></p>
      </header>
      <form [formGroup]="contactForm">
        <div class="card p-fluid feild-bg mb-5" formArrayName="contacts">
          <div class="p-formgrid grid">
            <div class="field col"></div>
            <div class="field col"></div>
            <div class="field col"></div>
            <div class="field col"></div>
          </div>
          <div *ngFor="let contact of contacts.controls; let i = index">
            <div class="p-formgrid grid" [formGroupName]="i">
              <!-- <div class="field col">
                <label for="telephone"><strong>Name</strong></label>
                <input type="tel" id="vm_name" formControlName="vm_name" [readonly]="isNotEditable" class="p-inputtext" required [ngClass]="newVmHighlightClass(i, 'vm_name')"/>
              </div> -->
              <div class="field col">
                <label for="telephone"><strong>Telephone</strong></label>
                <input type="tel" id="telephone" formControlName="telephone" [readonly]="isNotEditable" class="p-inputtext" required [ngClass]="newVmHighlightClass(i, 'telephone')"/>
              </div>
              <div class="field col">
                <label for="email"><strong>Email ID</strong></label>
                <input type="email" id="email" formControlName="email_id" [readonly]="isNotEditable" class="p-inputtext" required [ngClass]="newVmHighlightClass(i, 'email_id')"/>
              </div>
              <div class="field col">
                <label for="mobile"><strong>Mobile Number</strong></label>
                <input type="tel" id="mobile" formControlName="mobile_phone" [readonly]="isNotEditable" class="p-inputtext" required [ngClass]="newVmHighlightClass(i, 'mobile_phone')"/>
              </div>
              <!-- <div class="field col mt-5" *ngIf="i === 0"> -->
                <!-- <button pButton type="button" label="Add More" class="p-button-sm p-button-primary"
                  ></button> -->
              <!-- </div> -->
              <!-- <div class="field col" style="margin-top: 3.2%" *ngIf="i !== 0"> -->
                <!-- <button pButton type="button" class="p-button-sm p-button-danger" (click)="removeContact(i)" *ngIf="i > 1"
                  icon="fas fa-xmark"></button> -->
              <!-- </div> -->
            </div>
          </div>
        </div>
      </form>

      <header class="orange-center mb-5">
        <p><strong>CONTACT PERSON</strong></p>
      </header>
      <form [formGroup]="rockmancontactForm">
        <div class="card p-fluid" formArrayName="rockmancontacts">
          <div class="p-formgrid grid">
            <div class="field col"></div>
            <div class="field col"></div>
            <div class="field col"></div>
          </div>
          <div *ngFor="let rockamncontact of rockmancontacts.controls; let i = index">
            <div class="p-formgrid grid" [formGroupName]="i">
              <div class="field col">
                <label for="telephone"><strong>First Name</strong></label>
                <input type="tel" id="first_name" formControlName="first_name" [readonly]="isNotEditable" class="p-inputtext" required [ngClass]="RCHighlightClass(i, 'first_name')"/>
              </div>
              <div class="field col">
                <label for="telephone"><strong>Last Name</strong></label>
                <input type="tel" id="last_name" formControlName="last_name" [readonly]="isNotEditable" class="p-inputtext" required [ngClass]="RCHighlightClass(i, 'last_name')"/>
              </div>
              <div class="field col" [ngClass]="RCHighlightClass(i, 'rockman_contact_department')">
                <label for="Rockman_contact_department"><strong>Department</strong></label>
                <p-dropdown [options]="Rockman_contact_department" [readonly]="isNotEditable" id="Rockman_contact_department"
                  formControlName="rockman_contact_department" placeholder="Select Department"></p-dropdown>
              </div>
              <div class="field col" [ngClass]="RCHighlightClass(i, 'rockman_contact_function')">
                <label for="Rockman_contact_function"><strong>Function</strong></label>
                <p-dropdown [options]="Rockman_contact_function" [readonly]="isNotEditable" id="Rockman_contact_function"
                  formControlName="rockman_contact_function" placeholder="Select Function"></p-dropdown>
              </div>
              <!-- <div class="field col mt-5" *ngIf="i === 0"> -->
                <!-- <button pButton type="button" label="Add More" class="p-button-sm p-button-primary"
                  ></button> -->
                  <!-- (click)="addRockmanContact()" -->
              <!-- </div> -->
              <!-- <div class="field col mt-4" *ngIf="i !== 0"> -->
                <!-- <button pButton type="button" icon="fas fa-xmark" class="p-button-sm p-button-danger mt-2"
                  (click)="removeRockmanContact(i)" *ngIf="i > 0"></button> -->
              <!-- </div> -->
            </div>
          </div>
        </div>
      </form>

      <div *ngIf="!isVendor && !isAuditor">
      <header class="orange-center mb-5">
        <p><strong>Thrid Party Score</strong></p>
      </header>

      <div class="p-formgrid grid">
        <div class="field col feild-bg" >
          <label for="msme_no"><strong>3rd Party Evaluated Score</strong></label>
          <!-- <p-dropdown [options]="scoreList" [(ngModel)]="evaluatedScore"
           [required]="true" appendTo="body"
          styleClass="w-17rem" />  -->
          <input type="tel" id="first_name" formControlName="thrid_party_evaluated_score" [readonly]="isNotEditable" class="p-inputtext" required />
        </div>
        <div class="field col feild-bg">
          <div class="field col" style="width: fit-content">
            <label htmlFor="Cancel-cheq" *ngIf="riskScore_doc">
                <label for="msme_no"><strong>3rd Party Business Score Document</strong></label>
            </label>
            <div class="p-formgrid grid">
                <div class="field col">
                    <button pButton class="btn btn-primary" style="max-width: min-content;"
                      *ngIf="riskScore_doc" (click)="downloadFile(riskScore_doc, 'thrid_party_business_score_doc')">
                      <i class="pi pi-download"></i>
                    </button>
                  </div>
            </div>
          </div>
        </div>
        <div class="field col feild-bg">
          <label for="msme_no"><strong>3rd Party Risk Score</strong></label>
          <!-- <p-dropdown [options]="scoreList" [(ngModel)]="riskScore"
          [required]="true" appendTo="body" styleClass="w-17rem" /> -->
          <input type="tel" id="first_name" formControlName="thrid_party_risk_score" [readonly]="isNotEditable" class="p-inputtext" required />
        </div>
        <div class="field col feild-bg">
          <div class="field col" style="width: fit-content">
            <label htmlFor="Cancel-cheq" *ngIf="evaluatedScore_doc">
                <label for="msme_no"><strong>3rd Party Evaluated Scorecard Document</strong></label>
            </label>
            <div class="p-formgrid grid">
                <div class="field col">
                    <button pButton class="btn btn-primary" style="max-width: min-content;"
                      *ngIf="evaluatedScore_doc" (click)="downloadFile(evaluatedScore_doc, 'thrid_party_evaluated_scorecard_doc')">
                      <i class="pi pi-download"></i>
                    </button>
                  </div>
            </div>
          </div>
        </div>
      </div>
       </div>
       <!-- <div *ngIf="vendor_query_remark && isFinalApproved">
       <header class="orange-center mb-5" >
        <p><strong>Vendor Query</strong></p>
      </header>
      <div>
        <h5><strong class="long-text">{{vendor_query_remark}}</strong></h5>
      </div>
    </div> -->

      <!-- <div style="display: flex; justify-content: center" class="mt-5">
        <div>
          <p-checkbox formControlName="note" [binary]="true" inputId="binary" />
        </div>
        <div>
          <a href="https://rocknet.rockman.in/Vendor2_New/Supplier_code_of_conduct_for_Sustainable_Procurement_Rockman.pdf"
            class="ml-5" target="_blank"><strong style="color: red">I have read and accepted (Click here to read SUPPLIER
              CODE OF
              CONDUCT FOR SUSTAINABLITY PROCUREMENT & SELF DECLARATION)</strong></a>
        </div>
      </div> -->
      <div style="margin-top: 20px"></div>
      <!-- <div style="display: flex; justify-content: center; align-items: center"  *ngIf="isVendorStatus">
        <button pButton type="button" style="
            display: flex;
            justify-content: center;
            align-items: center;
            width: 70px;
          " label="Approve" pTooltip="Are You Sure You Want To Approve!" severity="success" (click)="openConfirmationDialog()"></button> -->
        <!-- <button pButton  type="button" style="
            display: flex;
            justify-content: center;
            align-items: center;
            width: 70px;
            margin-left: 30;
          " pTooltip="Are You Sure You Want To Reject!" [disabled]="!selectedVendorList || !selectedVendorList.length"
           severity="danger" (click)="openRejectDialog()" label="Reject"></button>
           -->
          <!-- (click)="submitForm()" -->
      <!-- </div> -->
      <div class="grid">
        <div class="col" style="display: flex; justify-content: center; " *ngIf="isVendorStatus && showApprovalButtons">
          <p-button pRipple label="Approve" icon="pi pi-check" class="mr-2" severity="success"
            (click)="openConfirmationDialog()" [disabled]="!selectedVendorList || !selectedVendorList.length" pTooltip="Are You Sure You Want To Approve!"></p-button>
          <p-button pRipple label="Reject" icon="pi pi-times" class="mr-2" severity="danger" (click)="openRejectDialog()"
            [disabled]="!selectedVendorList || !selectedVendorList.length" pTooltip="Are You Sure You Want To Reject!"></p-button>
          <p-button pRipple label="Vendor Query" icon="pi pi-check" class="mr-2" severity="info" (click)="openVendorQueryDialog()"
            [disabled]="!selectedVendorList || !selectedVendorList.length"></p-button>
        </div>
      </div>
    </div>

    <p-dialog header="Missing Required Fields" [(visible)]="displayDialog" [modal]="true" [style]="{ width: '50vw' }">
      <div *ngIf="missingFields.length > 0">
        <p>The following fields are required and need to be filled:</p>
        <ul>
          <li *ngFor="let field of missingFields">{{ field }}</li>
        </ul>
      </div>
      <p-footer>
        <button type="button" pButton label="Close" (click)="closeDialog()"></button>
      </p-footer>
    </p-dialog>
  </form>
  <p-confirmDialog header="Confirm Approval" [visible]="isApproveDialog" [style]="{ 'width': '40%' }" [closable]="false">
    <ng-template pTemplate="message">
      <div class="grid mb-0">
        <div style="text-align: center" class="col-12">
          <strong>Are you sure you want to approve the selected vendors?</strong>
        </div>
        <div class="col-12" *ngIf="isPendingApproval1">
          <div class="grid mt-3" style="text-align: center;">
            <div class="col">
              <label htmlFor="MCAFILE"><strong>Account Group</strong></label>
              <p-dropdown [options]="accountGroupList" [(ngModel)]="newAccountGroup"
                optionLabel="label" optionValue="value"  appendTo="body"
                styleClass="w-17rem" />
              <!-- <input
                  pInputText
                  [(ngModel)]="accountgroup" placeholder="Reconciliation Account (Required)" style="width: 100%;" required/>  -->
                <!-- <label htmlFor="MCAFILE"><strong>Reconciliation Account</strong></label>
              <p-dropdown [options]="vendorPayableAccountsList" [(ngModel)]="accountgroup"
                 optionLabel="description" optionValue="code"
                appendTo="body" styleClass="w-17rem" /> -->
            </div>
            <div class="col">
              <!-- <label>Payment Term</label> -->
              <label htmlFor="MCAFILE"><strong>Purchasing Organization</strong></label>
              <p-dropdown [options]="PurchasingOrganization" [(ngModel)]="purchasingOrganization"
                optionLabel="label" optionValue="value"  appendTo="body"
                styleClass="w-17rem" />
            </div>
          </div>
          <div class="grid mt-3" style="text-align: center;">
            <div class="col"></div>
            <div class="col">
              <!-- <label>Payment Term</label> -->
              <label htmlFor="MCAFILE"><strong>Payment Term</strong></label>
              <p-dropdown [options]="paymentterm1" [(ngModel)]="paymentTerm"
                optionLabel="payment_term_description" optionValue="payment_term_code"  appendTo="body"
                styleClass="w-17rem" />
            </div>
            <div class="col"></div>
          </div>
        </div>
        <div class="col-12" *ngIf="pendingreview">
          <div class="grid" style="text-align: center;">
            <div class="col">
              <div class="field col">
                <label htmlFor="MCAFILE"><strong>3rd Party Business Score Document</strong></label>
                <p-fileUpload mode="basic" name="uploadGstFile[]" accept="image/*,.pdf,.xls,.xlsx"
                  [maxFileSize]="25000000" (onSelect)="onUploadFile($event,'thrid_party_business_score_doc')"
                  chooseLabel="Upload File"
                  pTooltip=".pdf, .jpg, .png, .jpeg, .xlsx, .docs Extenstion Accepted (Max file size 25MB)"
                  tooltipPosition="right" *ngIf="!thrid_party_business_score_doc" styleClass="w-17rem"></p-fileUpload>
                <div *ngIf="thrid_party_business_score_doc">
                  <span>{{thrid_party_business_score_doc.name}}</span>
                  <button type="button" pButton icon="pi pi-check"
                    class="p-fileupload-close p-button-rounded p-button-success"
                    (click)="cancelUpload('thrid_party_business_score_doc')"></button>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="field col">
                <label htmlFor="MCAFILE"><strong>3rd Party Evaluated Scorecard Document</strong></label>
                <p-fileUpload mode="basic" name="uploadGstFile[]" accept="image/*,.pdf,.xls,.xlsx"
                  [maxFileSize]="25000000" (onSelect)="onUploadFile($event,'thrid_party_evaluated_scorecard_doc')"
                  chooseLabel="Upload File"
                  pTooltip=".pdf, .jpg, .png, .jpeg, .xlsx, .docs Extenstion Accepted (Max file size 25MB)"
                  tooltipPosition="right" *ngIf="!thrid_party_evaluated_scorecard_doc"
                  styleClass="w-17rem"></p-fileUpload>
                <div *ngIf="thrid_party_evaluated_scorecard_doc">
                  <span>{{thrid_party_evaluated_scorecard_doc.name}}</span>
                  <button type="button" pButton icon="pi pi-check"
                    class="p-fileupload-close p-button-rounded p-button-success"
                    (click)="cancelUpload('thrid_party_evaluated_scorecard_doc')"></button>
                </div>
              </div>
            </div>
          </div>
          <div class="grid" style="text-align: center;">
            <div class="col">
              <!-- <label>Account Group</label> -->
              <!-- <input
                pInputText
                [(ngModel)]="accountgroup" placeholder="Reconciliation Account (Required)" style="width: 100%;" required/>  -->
                <label htmlFor="MCAFILE"><strong>3rd Party Evaluated Score</strong></label>
              <p-dropdown [options]="scoreList" [(ngModel)]="evaluatedScore"
                 appendTo="body"
                styleClass="w-17rem" />
            </div>
            <div class="col">
              <!-- <label>Payment Term</label> -->
              <label htmlFor="MCAFILE"><strong>3rd Party Risk Score</strong></label>
              <p-dropdown [options]="scoreList" [(ngModel)]="riskScore"
                 appendTo="body" styleClass="w-17rem" />
            </div>

          </div>
        </div>
         <div class="col-12" *ngIf="isPendingApproval2">
          <div class="grid" style="text-align: center;">
            <!-- <div class="col">
              <label><strong> With Holding Tax </strong></label>
            </div> -->
            <div class="col">
              <label><strong> With Holding Tax </strong></label>
              <p-dropdown [options]="withholdingtax1" [(ngModel)]="withholdingtax"
              styleClass="w-17rem"
              optionLabel="label" optionValue="value"  appendTo="body"
              (ngModelChange)="OnChangeWithholding($event)" />
            </div>
            <div class="col">
              <!-- <label>Account Group</label> -->
              <!-- <input
                  pInputText
                  [(ngModel)]="accountgroup" placeholder="Reconciliation Account (Required)" style="width: 100%;" required/>  -->
                <label htmlFor="MCAFILE"><strong>Reconciliation Account</strong></label>
              <p-dropdown [options]="vendorPayableAccountsList" [(ngModel)]="accountgroup"
                 optionLabel="description" optionValue="code"
                appendTo="body" styleClass="w-17rem" />
            </div>
          </div>
          <!--<div *ngIf="isWithHoldingTaxYes">

            <div class="col-12">
              <div class="grid">
                <div class="col">
                  <label><strong> Name</strong></label>
                  <p-dropdown [options]="reconciliationTypeList" [(ngModel)]="RectyData" optionLabel="description"
                    appendTo="body" styleClass="w-20rem" (ngModelChange)="OnChangeReconciliation($event)" />
                </div>
                <div class="col">
                  <label><strong> Reconciliation type </strong></label>
                  <input pInputText [(ngModel)]="reconciliationName" style="width: 100%;"  />
                </div>
                <div class="col-12">
                  <div class="grid">
                    <div class="col">
                      <label><strong> Name</strong></label>
                      <p-dropdown [options]="withHoldingTaxTypeList" [(ngModel)]="Wthttype" optionLabel="description"
                        styleClass="w-20rem" appendTo="body" (ngModelChange)="OnChangeWithholdingTaxType($event)" />
                    </div>
                    <div class="col">
                      <label><strong> With Holding Tax Type </strong></label>
                      <input pInputText [(ngModel)]="WithHoldingTaxType" style="width: 100%;"  />
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="grid">
                    <div class="col">
                      <label><strong> Name </strong></label>
                      <p-dropdown [options]="withHoldingTaxCode" [(ngModel)]="Wtaxcode" optionLabel="description"
                        appendTo="body" styleClass="w-20rem" (ngModelChange)="OnChangeWithholdingTaxCode($event)" />
                    </div>
                    <div class="col">
                      <label><strong> With Holding Tax Code </strong></label>
                      <input pInputText [(ngModel)]="WithHoldingTaxCodeName" style="width: 100%;"  />
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="grid">
                    <div class="col">
                      <label><strong> Exemption Number </strong></label>
                      <input pInputText [(ngModel)]="ExemptionNumber" style="width: 100%;"  />
                    </div>
                    <div class="col">
                      <label><strong> Exem.%</strong></label>
                      <input pInputText [(ngModel)]="Exem" style="width: 100%;"  />
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="grid">
                    <div class="col">
                      <label class="font-bold block mb-2"> Exempt From </label>
                      <p-calendar inputId="calendar-24h" [(ngModel)]="ExemptFrom" dateFormat="dd-mm-yy"
                        [style]="{'width': '100%'}" appendTo="body" [showIcon]="true" />
                    </div>
                    <div class="col">
                      <label class="font-bold block mb-2"> Exempt To </label>
                      <p-calendar inputId="calendar-24h" [(ngModel)]="ExemptTo" appendTo="body" dateFormat="dd-mm-yy"
                        [style]="{'width': '100%'}" [showIcon]="true" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>-->
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <div class="flex justify-content-end mt-0">
        <button type="button" pButton label="Cancel" icon="pi pi-times" (click)="closeConfirmationDialog()"></button>
        <button type="button" pButton label="Approve" icon="pi pi-check" (click)="approvedVendor()"
          [disabled]="!isFormValid()"></button>
      </div>
    </ng-template>
  </p-confirmDialog>


  <p-sidebar
    [(visible)]="sidebarVisible"
    position="right"
    [style]="{ width: '50%' }"
    [showCloseIcon]="false"
  >
  <div class="col-12" *ngIf="isPendingApproval2">

    <div style="display:flex;justify-content: end">
      <p-button pRipple icon="pi pi-times" severity="danger"
      (click)="oncloseHolding()" [style]="{'font-size': '5px'}"></p-button>
    </div>

    <!-- <div class="grid" style="text-align: center;"> -->
      <!-- <div class="col-8">
        <label class="font-bold block mb-2"> With Holding Tax </label>
        <p-dropdown [options]="withholdingtax1" [(ngModel)]="withholdingtax"
          [style]="{'width': '50%','text-align':'center'}"
          optionLabel="label" optionValue="value" appendTo="body"
          (ngModelChange)="OnChangeWithholding($event)" />
      </div>
      <div class="col-4" *ngIf="isApproved2">
        <p-button pRipple label="Approve" icon="pi pi-check" [style]="{'margin-top': '20px'}" severity="success"
                (click)="approvedVendor()"></p-button>
      </div> -->
      <!-- <div class="col">
           <p-dropdown
           [options]="withholdingtax1"
           [(ngModel)]="withholdingtax"
           placeholder="With Holding Tax (Required)"
           [style]="{'width': '50%','text-align':'start'}"
           optionLabel="label"
           optionValue="value"
           [required]="true"
           appendTo="body"
           />
    </div> -->
    <!-- </div> -->
    <div>

      <div class="col-12">
        <!-- <div class="col-12"> -->
          <div class="grid">
            <div class="col">
              <label><strong> With Holding Tax </strong></label>
              <p-dropdown [options]="withholdingtax1" [(ngModel)]="withholdingtax"
              styleClass="w-25rem"
              optionLabel="label" optionValue="value"  appendTo="body"
              (ngModelChange)="OnChangeWithholding($event)" />
            </div>
            <div class="col">
              <!-- <label>Account Group</label> -->
              <!-- <input
                  pInputText
                  [(ngModel)]="accountgroup" placeholder="Reconciliation Account (Required)" style="width: 100%;" required/>  -->
                <label htmlFor="MCAFILE"><strong>Reconciliation Account</strong></label>
              <p-dropdown [options]="vendorPayableAccountsList" [(ngModel)]="accountgroup"
                 optionLabel="description" optionValue="code"
                appendTo="body" styleClass="w-25rem" />
            </div>
            <!-- <div class="col">
              <label><strong> Exemption Number </strong></label>
              <input pInputText [(ngModel)]="ExemptionNumber" style="width: 100%;"  />
            </div>
            <div class="col">
              <label><strong> Exem.%</strong></label>
              <input pInputText [(ngModel)]="Exem" style="width: 100%;"  />
            </div> -->
          </div>
        <!-- </div> -->
        <div class="grid mt-5" *ngIf="isWithHoldingTaxYes">
          <div class="col">
            <label><strong> Name </strong></label>
            <p-dropdown [options]="withHoldingTaxTypeList" [(ngModel)]="Wthttype" optionLabel="description"
              styleClass="w-25rem" appendTo="body" (ngModelChange)="OnChangeWithholdingTaxType($event)" />
          </div>
          <div class="col">
            <label><strong> With Holding Tax Type </strong></label>
            <input pInputText [(ngModel)]="WithHoldingTaxType" style="width: 100%;" required />
          </div>
          <!-- <div class="col-12">
            <div class="grid"> -->

            <!-- </div>
          </div> -->
          <div class="col-12">
            <div class="grid">
              <div class="col">
                <label><strong> Name </strong></label>
                <p-dropdown [options]="withHoldingTaxCode" [(ngModel)]="Wtaxcode" optionLabel="description"
                  appendTo="body" styleClass="w-25rem" (ngModelChange)="OnChangeWithholdingTaxCode($event)" />
              </div>
              <div class="col">
                <label><strong> With Holding Tax Code </strong></label>
                <input pInputText [(ngModel)]="WithHoldingTaxCodeName" style="width: 100%;"  />
              </div>
              <!-- <div class="col">
                <label><strong> Exemption Number </strong></label>
                <input pInputText [(ngModel)]="ExemptionNumber" style="width: 100%;"  />
              </div>
              <div class="col">
                <label><strong> Exem.%</strong></label>
                <input pInputText [(ngModel)]="Exem" style="width: 100%;"  />
              </div> -->
            </div>
          </div>
          <!-- <div class="col-12">
            <div class="grid"> -->

            <!-- </div>
          </div> -->
          <div class="col-12">
            <div class="grid">
              <div class="col">
                <label><strong> Name</strong></label>
                <p-dropdown [options]="reconciliationTypeList" [(ngModel)]="RectyData" optionLabel="description"
                  appendTo="body" styleClass="w-25rem" (ngModelChange)="OnChangeReconciliation($event)" />
              </div>
              <div class="col">
                <label><strong> Reconciliation type</strong></label>
                <input pInputText [(ngModel)]="reconciliationName" style="width: 100%;" required />
              </div>
              <!-- <div class="col-3">
                <label class="font-bold block mb-2"> Exempt From </label>
                <p-calendar inputId="calendar-24h" [(ngModel)]="ExemptFrom" dateFormat="dd-mm-yy"
                  [style]="{'width': '100%'}" appendTo="body" [showIcon]="true" />
              </div>
              <div class="col-3">
                <label class="font-bold block mb-2"> Exempt To </label>
                <p-calendar inputId="calendar-24h" [(ngModel)]="ExemptTo" appendTo="body" dateFormat="dd-mm-yy"
                  [style]="{'width': '100%'}" [showIcon]="true" />
              </div> -->

            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="grid">
            <div class="col"></div>
            <!-- <div class="col" *ngIf="!isWithHoldingTaxYes"></div> -->
            <div class="col" *ngIf="isWithHoldingTaxYes">
              <!-- [style]="{'margin-left':'300px'}" -->
              <p-button pRipple (click)="addWithholding()" [style]="{'width': '100px'}" [disabled]="!isFormValid2()" icon="pi pi-plus"  label="Add"></p-button>
            </div>
          <div class="col">
            <p-button pRipple label="Approve" icon="pi pi-check" severity="success"
            (click)="approvedVendor()"  [disabled]="!isFormValid1()"></p-button>
          </div>
          <div class="col"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="withHoldingMultiData.length > 0">
    <p-table styleClass="p-datatable-sm" [value]="withHoldingMultiData" [tableStyle]="{ 'min-width': '50rem'}">
        <ng-template pTemplate="header">
            <tr>
                <th>Wth.t.type</th>
                <th>Name</th>
                <th>W/tax code</th>
                <th>Name</th>
                <th>Rec.ty</th>
                <th>Name</th>
                <!-- <th>Exemption Number</th>
                <th>Exem.%</th>
                <th>Exempt From</th>
                <th>Exempt To</th> -->
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
            <tr>
                <td>{{ data.with_holding_tax_type }}</td>
                <td>{{ data.with_holding_tax_type_name }}</td>
                <td>{{ data.with_holding_tax_code }}</td>
                <td>{{ data.with_holding_tax_code_name }}</td>
                <td>{{ data.reconciliation_type }}</td>
                <td>{{ data.reconciliation_name }}</td>
                <!-- <td>{{ data.exemption_number }}</td>
                <td>{{ data.exem }}</td>
                <td>{{ data.exempt_from | date:'dd-MM-yy' }}</td>
                <td>{{ data.exempt_to | date:'dd-MM-yy'  }}</td> -->
            </tr>
        </ng-template>
    </p-table><br><br>
  </div>
  </p-sidebar>


  <p-confirmDialog header="Confirm Rejection" [visible]="isRejectDialog" [style]="{ 'width': '40%' }" [closable]="false">
    <ng-template pTemplate="message">
      <div class="grid mb-0">
        <div style="text-align: center" class="col-12">
          <strong>Are you sure you want to reject the selected vendors?</strong>
        </div>
        <div class="col-12">
          <div class="grid" style="text-align: center;">
            <input pInputText [(ngModel)]="rejectReason" placeholder="Reject Reason(Required)" style="width: 100%;"
              required />
          </div>
        </div>
      </div>

    </ng-template>
    <ng-template pTemplate="footer">
      <div class="flex justify-content-end mt-0">
        <button type="button" pButton label="Cancel" icon="pi pi-times" (click)="closeRejectDialog()"></button>
        <button type="button" pButton label="Reject" icon="pi pi-check" (click)="onReject()"
          [disabled]="!rejectReason"></button>
      </div>
    </ng-template>
  </p-confirmDialog>


  <p-confirmDialog header="Confirm" [visible]="pendingApprovalForDialog" [style]="{ 'width': '40%' }" [closable]="false">
    <ng-template pTemplate="message">
      <div class="grid mb-0">
        <div style="text-align: center" class="col-12">
          <strong>Are you sure you want to approve the selected vendor change request?</strong>
        </div>
      </div>

    </ng-template>
    <ng-template pTemplate="footer">
      <div class="flex justify-content-end mt-0">
        <button type="button" pButton label="Cancel" icon="pi pi-times" (click)="pendingApprovalForDialog = false"></button>
        <button type="button" pButton label="Approve" icon="pi pi-check" (click)="onApproveChangeRequest()"
          ></button>
      </div>
    </ng-template>
  </p-confirmDialog>

  <p-confirmDialog header="Confirm Rejection" [visible]="pendingRejectForDialog" [style]="{ 'width': '40%' }" [closable]="false">
    <ng-template pTemplate="message">
      <div class="grid mb-0">
        <div style="text-align: center" class="col-12">
          <strong>Are you sure you want to reject the selected vendor ?</strong>
        </div>
      </div>

    </ng-template>
    <ng-template pTemplate="footer">
      <div class="flex justify-content-end mt-0">
        <button type="button" pButton label="Cancel" icon="pi pi-times" (click)="pendingRejectForDialog = false"></button>
        <button type="button" pButton label="Reject" icon="pi pi-check" (click)="onRejectChangeRequest()"
          ></button>
      </div>
    </ng-template>
  </p-confirmDialog>

  <p-confirmDialog header="Vendor Query" [visible]="is_need_Detail" [style]="{ 'width': '40%' }" [closable]="false">
    <ng-template pTemplate="message">
        <div class="col-12">
          <div class="grid" style="text-align: center;">
            <label for="Company_Title"><strong>Remark</strong>&nbsp;&nbsp;&nbsp;</label>
            <textarea rows="10" cols="100" pInputTextarea [(ngModel)]="remark_for_vendor_query"> </textarea>
          </div>
        </div>

    </ng-template>
    <ng-template pTemplate="footer">
      <div class="flex justify-content-end mt-0">
        <button type="button" pButton label="Close" icon="pi pi-times" (click)="is_need_Detail = false"></button>
        <button type="button" pButton label="Submit" icon="pi pi-check" [disabled]="!remark_for_vendor_query" (click)="onSubmitVendorQuery()"
          ></button>
      </div>
    </ng-template>
  </p-confirmDialog>


  <p-confirmDialog header="Change Details" [visible]="isDialogSummary" [closable]="false" [style]="{ width: '60%' }">
    <ng-template pTemplate="message">
      <div style="overflow: hidden;">
        <p-table
            [value]="getFilteredDetails()"
            styleClass="p-datatable-gridlines"
            [tableStyle]="{ 'min-width': '100rem' }"
            [scrollable]="true"
            scrollHeight="400px">
          <ng-template pTemplate="header">
            <tr>
              <th style="text-align: center;">Field</th>
              <th style="text-align: center;">Old Detail</th>
              <th style="text-align: center;">New Detail</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-detail>
            <tr>
              <td>{{ getShortKey(detail.key) }}</td>
              <td>{{ detail.oldValue }}</td>
              <td>{{ detail.newValue }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <div class="flex justify-content-end mt-0">
        <button type="button" pButton label="Cancel" icon="pi pi-times" (click)="isDialogSummary = false"></button>
      </div>
    </ng-template>
  </p-confirmDialog>

  <p-toast></p-toast>

  <!-- Loading Screen -->
  <div *ngIf="isLoading" class="loading-overlay">
    <app-loading-screen></app-loading-screen>
  </div>
